import React, { Suspense, lazy, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Routes,
  Route,
  Outlet,
  useNavigate,
  HashRouter,
} from "react-router-dom";
import Loading from "./components/Loading";
import { MENU_LIST } from "./routes/constant";
import { getDataLogin } from "./utils/getDataLogin";
import { filterMenuList } from "./utils/filterRoute";
import API from "./services/api-request";
import { filteredRoutes } from "./config/constants";

// Pages
const Layout = lazy(() => import("./layouts"));
const Login = lazy(() => import("./pages/noauth/Login"));
const Adon = lazy(() => import("./pages/noauth/Adon"));
const Log = lazy(() => import("./pages/noauth/Log"));
const Utils = lazy(() => import("./pages/noauth/Utils"));
const Profile = lazy(() => import("./pages/auth/Profile"));

const AfterLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!getDataLogin()) {
      navigate("login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{getDataLogin() ? <Outlet /> : <Navigate to="/login" />}</>;
};

const NoAuth = () => {
  return <>{getDataLogin() ? <Navigate to="/dashboard" /> : <Outlet />}</>;
};

function App() {
  const [routeList, setRouteList] = useState([]);

  // Call route API & Filter the Menu
  const routeAPI = async () => {
    if (getDataLogin()) {
      await API.Get(`control-list/privilege_id/${getDataLogin().privilege_id}`)
        .then((result) => {
          const menuFromAPI = result.data.menu;
          setRouteList(filterMenuList(MENU_LIST, menuFromAPI));
        })
        .catch((err) => {
          console.error(err);
          return [];
        });
    }
  };

  // Render Selected Menu
  const renderRoutes = (menuList) => {
    return menuList.map((e) => {
      if (e.children && e.children.length > 0) {
        const childRoutes = renderRoutes(e.children);
        return (
          <Route key={e.name} element={e.element}>
            {childRoutes}
          </Route>
        );
      }
      return <Route key={e.name} path={e.path} element={e.element} />;
    });
  };

  useEffect(() => {
    setTimeout(() => {
      routeAPI();
    }, 1000);
  }, []);

  return (
    <HashRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route element={<AfterLogin />}>
            <Route element={<Layout />}>{renderRoutes(MENU_LIST)}</Route>
            <Route element={<Layout />}>
              <Route path="/profile" element={<Profile />} />
            </Route>
          </Route>
          <Route element={<NoAuth />}>
            <Route exact path="/login" element={<Login />} />
          </Route>

          <Route path="/adon" element={<Adon />} />
          <Route path="/log" element={<Log />} />
          <Route path="/utils" element={<Utils />} />

          {/* Bypass Route, nanti dihapus */}
          {/* <Route element={<Layout />}>{renderRoutes(MENU_LIST)}</Route> */}

          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Suspense>
    </HashRouter>
  );
}

export default App;
